var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "percentage-circle-wrapper" }, [
    _c(
      "svg",
      { staticClass: "circular-chart orange", attrs: { viewBox: "0 0 36 36" } },
      [
        _c("path", {
          staticClass: "circle-bg",
          attrs: {
            d: "M18 2.0845\n        a 15.9155 15.9155 0 0 1 0 31.831\n        a 15.9155 15.9155 0 0 1 0 -31.831",
          },
        }),
        _vm._v(" "),
        _c("path", {
          staticClass: "circle",
          attrs: {
            "stroke-dasharray": `${_vm.value}, 100`,
            d: "M18 2.0845\n        a 15.9155 15.9155 0 0 1 0 31.831\n        a 15.9155 15.9155 0 0 1 0 -31.831",
          },
        }),
        _vm._v(" "),
        _c(
          "text",
          { staticClass: "percentage", attrs: { x: "18", y: "20.35" } },
          [_vm._v(_vm._s(_vm.text))]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }